import React from 'react'
import PropTypes from 'prop-types'
import { LogosArea } from 'LiveBoard/components/shared/LogosArea'
import { PasswordContainer, PasswordImage } from './types/Password'
import { EmailVerificationContainer, EmailVerificationImage } from './types/EmailVerification'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import style from './style.css.scss'

const AUTHORIZATION_COMPONENTS = {
  password: {
    authComponent: PasswordContainer,
    imageComponent: PasswordImage
  },
  email_verification: {
    authComponent: EmailVerificationContainer,
    imageComponent: EmailVerificationImage
  }
}

const Authorization = (props) => {
  const getComponentsToDisplay = () => {
    return AUTHORIZATION_COMPONENTS[props.authorizationType] || {}
  }

  const config = {
    logo: get(props, 'config.logo'),
    icon: get(props, 'config.icon'),
    secondaryLogo: get(props, 'config.secondary_logo'),
    privacyMessage: get(props, 'config.privacy_message')
  }

  const displayPageProperties = {
    title: get(props, 'designPageProperties.title', {}),
    subtitle: get(props, 'designPageProperties.subtitle', {}),
    leftBackgroundColor: get(props, 'designPageProperties.left_background_color'),
    pageColor: get(props, 'designPageProperties.page_color'),
    rightImageUrl: get(props, 'designPageProperties.right_image_url')
  }

  const displayedComponents = getComponentsToDisplay()

  const AuthComponent = displayedComponents.authComponent
  const ImageComponent = displayedComponents.imageComponent

  const containerBackgroundStyle = isEmpty(displayPageProperties.pageColor) ? null : { backgroundColor: displayPageProperties.pageColor }
  const backgroundStyle = isEmpty(displayPageProperties.leftBackgroundColor) ? null : { backgroundColor: displayPageProperties.leftBackgroundColor }

  return (
    <div className='authorization-app-container' style={containerBackgroundStyle}>
      <div style={backgroundStyle} className='authorization-app'>
        <div className="auth-section">
          {
            props.config &&
            <div className="logos-section">
              <LogosArea
                config={config}
                withPadding={true} />
            </div>
          }
          { AuthComponent &&
            <AuthComponent locale={props.locale} privacyMessage={config.privacyMessage} pageProperties={displayPageProperties} />
          }
        </div>
        <div className="authorization-page-image-box">
          { ImageComponent && <ImageComponent imageUrl={displayPageProperties.rightImageUrl} /> }
        </div>
      </div>
    </div>
  )
}

Authorization.propTypes = {
  config: PropTypes.object,
  locale: PropTypes.string,
  authorizationType: PropTypes.string,
  designPageProperties: PropTypes.object
}

export default Authorization
